import { FunctionComponent } from "react";

import { Link } from "@ppb/the-wall-web";
import { Switch } from "@ppb/the-wall-web/components/bricks/Switch/Switch";

import { ToggleOptionProps } from "./ToggleOption.types";
import styles from "./ToggleOption.web.css";

const noop = () => {};

export const ToggleOption: FunctionComponent<ToggleOptionProps> = ({
  label,
  supportLink,
  isChecked,
  onChange,
  checkboxId,
  checkboxName,
  isDisabled,
  supportLinkCallback,
}) => {
  return (
    <div className={styles.container}>
      <p className={styles.label}>
        {label}
        {supportLink && (
          <span className={styles.supportLink}>
            <Link
              onClick={supportLinkCallback ?? noop}
              item={{
                isTextLink: true,
                viewLink: { viewUrl: supportLink.url },
                target: supportLink.target,
              }}
            >
              {supportLink.label}
            </Link>
          </span>
        )}
      </p>
      <Switch
        label={""}
        onChange={onChange}
        isChecked={isChecked}
        checkboxId={checkboxId}
        checkboxName={checkboxName}
        isDisabled={isDisabled}
      />
    </div>
  );
};
